export default __webpack_public_path__ + "3261f5a33b26814fe5b3f1799712bd7e.png";